export const baseURL = 'https://api.pwaspeed.com'
// export const baseURL = 'https://api-down.online-test.xyz'
